import THEME from 'app/styles/theme';

export const gradientBackgroundAnimation = (start, end, transTime) => `
  background-size: 100%;
  background-image: ${start};
  position: relative;
  z-index: 100;
  &:before {
    border-radius: inherit;
    background-image: ${end};
    content: '';
    display: block;
    height: 100%;
    position: absolute;
    top: 0; left: 0;
    opacity: 0;
    width: 100%;
    z-index: -100;
    transition: opacity ${transTime};
  }
  &:not(:disabled):hover {
     &:before {
       opacity: 1;
     }
  }
`;
